exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".formSubmissionSuccessful-root-_Qv {\n    display: grid;\n    gap: 1.5rem;\n}\n\n.formSubmissionSuccessful-text-7cA {\n    font-size: 0.875rem;\n    font-weight: 300;\n    line-height: 1.25rem;\n}\n\n.formSubmissionSuccessful-title-qyJ {\n    padding-top: 0.5rem;\n    text-transform: capitalize;\n}\n", ""]);

// Exports
exports.locals = {
	"root": "formSubmissionSuccessful-root-_Qv",
	"text": "formSubmissionSuccessful-text-7cA",
	"title": "formSubmissionSuccessful-title-qyJ"
};